import { Component, OnInit } from '@angular/core';
import { LessonStatus } from '@app/definitions/interfaces';
// import { GROUPS } from '@app/app.constants';

@Component({
    selector: 'app-profile-lessons',
    templateUrl: './profile-lessons.html',
    styleUrls: ['./profile-lessons.scss']
})
export class ProfileLessonsComponent implements OnInit {
    lesson_statuses = LessonStatus;

    ngOnInit() {}
}
